import { Component, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from 'src/app/shared/directives/paginator.component';
import { Observable, Subject, of, takeUntil } from 'rxjs';
import { PositionService } from 'src/app/shared/services/position.service';
import { Position } from '../models/position';
import { PositionSearch } from '../models/position-search';
import { faChartPie, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-position-list',
    templateUrl: './position-list.component.html',
    styleUrls: ['./position-list.component.scss'],
    standalone: false
})
export class PositionListComponent implements OnInit, OnDestroy {

  faChartPie: any = faChartPie;
  faMagnifyingGlass: any = faMagnifyingGlass;

  displayedColumns: string[] = ['symbol', 'quantity', 'avgPrice', 'longShort', 'openPos', 'eodPrice'];
  innerDisplayedColumns: string[] = ['quantity', 'avgPrice', 'longShort'];

  totalRecords = 0;
  allElements: Position[] = [];
  pagedElements$: Observable<Position[]>;
  private elementSearch: PositionSearch;

  pageIndex = 0;
  pageSize = 25;

  loading = false;
  searchExecuted = false;
  private onDestroy$ = new Subject<void>();

  constructor(private positionService: PositionService) { }

  ngOnInit(): void {
    this.positionService.searchExecuted$
      .pipe(
        takeUntil(this.onDestroy$)
      )
      .subscribe(positionSearch => {
        if (positionSearch.riaId > 0) {
          this.elementSearch = positionSearch;
          this.fetchGroupPositionSummary();
        } else {
          this.allElements = [];
          this.totalRecords = 0;
          this.getPagedData();
        }
      });
  }

  fetchGroupPositionSummary(): void {
    this.loading = true;
    this.positionService.getGroupPositionSummary(this.elementSearch)
      .subscribe(elements => {
        this.searchExecuted = true;
        this.allElements = elements;
        this.totalRecords = elements.length;
        this.getPagedData();
        this.loading = false;
      });
  }

  toggleRow(row: Position): void {
    row.expanded = !row.expanded;
    if (!row.symbolDetail) {
      row.loadingExpanded = true;

      this.positionService
        .getSymbolSummary({ riaId: this.elementSearch.riaId, symbol: row.symbol, group: this.elementSearch.group })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(symbol => {
          row.symbolDetail = symbol;
          row.loadingExpanded = false;
        });
    }
  }

  getPagedData(): void {
    const start = this.pageSize * this.pageIndex;
    const end = start + this.pageSize;
    this.pagedElements$ = of(this.allElements.slice(start, end));
  }

  pageChangeEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getPagedData();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
